import { EnvironmentProviders, Provider } from '@angular/core';

import { provideInviteDataAccess } from '@efficiently/client-data-access-invite';

export const inviteProviders: (Provider | EnvironmentProviders)[] = [provideInviteDataAccess()];
